// @flow
export const FETCH_SESSION_RESOURCE = 'session'
export const FETCH_SESSION_REQUEST = 'FETCH_SESSION_REQUEST'
export const FETCH_SESSION_ABORT_NO_TOKEN = 'FETCH_SESSION_ABORT_NO_TOKEN'
export const FETCH_SESSION_SUCCESS = 'FETCH_SESSION_SUCCESS'
export const FETCH_SESSION_FAILED = 'FETCH_SESSION_FAILED'

export const FETCH_USER_DATA_RESOURCE = 'userData'
export const FETCH_USER_DATA_REQUEST = 'FETCH_USER_DATA_REQUEST'
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS'
export const FETCH_USER_DATA_FAILED = 'FETCH_USER_DATA_FAILED'

export const SAVE_USER_ID = 'SAVE_USER_ID'
export const SAVE_USER_DATA = 'SAVE_USER_DATA'

export const CLEAR_SESSION = 'CLEAR_SESSION'

export const USER_ADDRESSES = 'userAddresses'



// WEBPACK FOOTER //
// ./src/services/session/constants.js